export class IMemberFreezeDetail {
    _id: string;
    totalFreezingDays: number;
    daysLeft: number;
    freezeDate: string;
    freezeEndDate: string;
    status: string;
    isFreeze: boolean;
    extraDays: number;
}